import React from "react";
import { Skeleton } from "@mui/lab";

import { StyledItem, StyledLabel, StyledNumber, StyledValue } from "../styles";

const StatisticItem = ({ label, value }) => (
  <StyledItem>
    <StyledLabel>{label}</StyledLabel>
    <StyledNumber paddingTop={!value}>
      {!value ? <Skeleton variant="text" width={100} height={15} /> : <StyledValue>{value}</StyledValue>}
    </StyledNumber>
  </StyledItem>
);

export { StatisticItem };

export default StatisticItem;
